import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Сегодня нерабочий день", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "schedule-list"
}

import timerIcon from '@/assets/icons/emojis/time.png';
import schoolIcon from '@/assets/icons/emojis/school.png';
import studentIcon from '@/assets/icons/emojis/student.png';
import bellIcon from '@/assets/icons/emojis/bell.png';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import getModifiedSchedule from '@/http/services/TeacherServices/SchedulePageServices/ModifiedScheduleService';
import { onMounted, reactive } from 'vue';
import { ModifiedScheduleStateModel } from '@/http/pageModels/teacherModels/schedulePage/ModifiedScheduleStateModel';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModifiedScheduleSubpage',
  setup(__props) {

const state = reactive<{ data: ModifiedScheduleStateModel }>({
    data: {} as ModifiedScheduleStateModel,
});

onMounted(() => {
    console.log('getModifiedScheduleSubpage');
    const mseVersion = localStorage.getItem('mseVersion');
    const teacherMse = localStorage.getItem('teachersMse');
    const mspVersion = localStorage.getItem('mspVersion');
    const msps = localStorage.getItem('modifiedScheduleParams');

    console.log('getModifiedScheduleSubpage');

    getModifiedSchedule(
        {
            mseVer: mseVersion && teacherMse ? mseVersion : 'null',
            mspVer: mspVersion && msps ? mspVersion : 'null',
            useVer: 'null',
            uspVer: 'null',
        },
        state
    );
});

return (_ctx: any,_cache: any) => {
  return (state.data.isDayOff)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (state.data.response && !state.data.isDayOff)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.response.todayClasses?.mseList, (mse) => {
            return (_openBlock(), _createBlock(UniversalCard, {
              props: {
                content:  mse.comments as string | undefined,
                type: 'elevated-secondary',
                title: `${mse.num}. ${mse.schoolClass.className}`,
                dataTags: [
                    {
                        iconCompleteUrl: _unref(getBaseUrl)() + mse.iconURL, 
                        color: 'var(--snotra--sys--surface)', 
                        title: mse.subjectFullName,
                    },
                    {
                        iconCompleteUrl: _unref(timerIcon),
                        color: 'var(--snotra--sys--surface)', 
                        title: `${state.data.response.msPsForToday.todayScheduleParams[mse.num-1].begin} - ${state.data.response.msPsForToday.todayScheduleParams[mse.num-1].end} (${state.data.response.msPsForToday.todayScheduleParams[mse.num-1].durationInMins} мин.)`,
                    },
                    {
                        iconCompleteUrl: _unref(schoolIcon),
                        color: 'var(--snotra--sys--surface)', 
                        title: mse.location,
                    },
                    {
                        iconCompleteUrl: _unref(studentIcon),
                        color: 'var(--snotra--sys--surface)',
                        title: mse.groupName ? mse.groupName : 'Весь класс ',
                    },
                    {
                        iconCompleteUrl: _unref(bellIcon),
                        color: 'var(--snotra--sys--surface)',
                        title: `Перемена после: ${state.data.response.msPsForToday.todayScheduleParams[mse.num-1].breakDurationInMins} мин.`,
                    },
                ], 
                buttons: [
                    {
                        iconName: 'supervised_user_circle',
                        innerText: 'Страница класса',
                        size: 'full-resizable-to-icon-large',
                        redirectToOnClick: `/teacher/classes/${mse.schoolClass.classId}/allStudents`,
                        type: 'outlined-transparent',
                    },
                    {
                        iconName: 'edit',
                        innerText: 'Изменить',
                        size: 'full',
                        type: 'filled',
                        redirectToOnClick: `/teacher/schedule/modify/${mse.mseUuid}?version=${mse.thisMseVersion}&returnTo=sn.teacher.schedule.mse`
                    }
                ]
            },
              key: mse.num,
              class: _normalizeClass(mse.schoolClass.colorSchemeName)
            }, null, 8, ["props", "class"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}
}

})